const content = document.getElementById('article-content');
let contentHtml = content.innerHTML;

// 1) Clean des balises BLOCK
contentHtml = contentHtml
    .replace(/\[\s*(?:&nbsp;|\s|<[^>\]]+>)*BLOCK(?:&nbsp;|\s|<[^>\]]+>)*\]/gi, '[BLOCK]')
    .replace(/\[\s*(?:&nbsp;|\s|<[^>\]]+>)*\/(?:&nbsp;|\s|<[^>\]]+>)*BLOCK(?:&nbsp;|\s|<[^>\]]+>)*\]/gi, '[/BLOCK]');

contentHtml = contentHtml
    .replace(/<p[^>]*>\s*(?:<span[^>]*>\s*)?\[BLOCK\]\s*(?:<\/span>\s*)?<\/p>/gi, '[BLOCK]')
    .replace(/<p[^>]*>\s*(?:<span[^>]*>\s*)?\[\/BLOCK\]\s*(?:<\/span>\s*)?<\/p>/gi, '[/BLOCK]');

contentHtml = contentHtml
    .replace(/\[BLOCK\]/gi, '<div class="article-row"><div class="text-wrapper">')
    .replace(/\[\/BLOCK\]/gi, '</div></div>');

content.innerHTML = contentHtml;

const articleRows = content.querySelectorAll('.article-row');
articleRows.forEach((articleRow) => {
  const imgWrapper = document.createElement('div');
  imgWrapper.className = 'img-wrapper';

  const textWrapper = document.createElement('div');
  textWrapper.className = 'text-wrapper';

  // Récupération de l'image
  const img = articleRow.querySelector('img');
  imgWrapper.appendChild(img);
  articleRow.appendChild(imgWrapper);
});

const emptyTags = content.querySelectorAll('.article-row p:empty');
emptyTags.forEach((emptyTag) => {
  emptyTag.remove();
})
